import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, orderBy, Timestamp, collection } from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';

//shortble
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import Itemwssortable from './item-ws-sortable';
//page links   
import '../workstation.css';
export default function Itemlistws({ data = {} }) {
    const [searchParams] = useSearchParams();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [adminguid, setadminguid] = useState(Cookies.get("adminguid"));
    const dateRef = useRef(null);
    const duedateRef = useRef(null); 
  const { puid, groupuid, taskuid } = data;
    const [itemdata, setItemdata] = useState([]);
    const [taskdata, setTaskdata] = useState([]);
    //  
    const capitalizeFirst = (str) =>
        str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
    //
    useEffect(() => { 
         setadminguid(Cookies.get("adminguid"));
       fetch_itemData();
    }, [data]);
    //fetch_taskData
    const fetch_itemData = async () => {
        setIsLoading(true);
        try {
         
            const itemQuery = query(
                collection(db, "projectstaskitem"),
                where("adminguid", "==", adminguid),
                where("puid", "==", puid),
                where("taskuid", "==", taskuid),
                where("status", "==", true),                
                where("groupuid", "==", groupuid),
                orderBy("indexstage", "asc")
            );
            const itemSnapshot = await getDocs(itemQuery);
            const itemdataList = itemSnapshot.docs.map((docItem) => ({
                id: docItem.id,
                ...docItem.data()
            }));  
           // setTaskdata(dataList);
            setItemdata(itemdataList);
  
        } catch (error) {
            console.error("Error fetching projects:", error);
        } finally {
            setIsLoading(false);
        }
    };    
    const handleDragEnd = async (event) => {
        const { active, over } = event;
        if (!active || !over || active.id === over.id) return;
        const oldIndex = itemdata.findIndex((item) => item?.id === active.id);
        const newIndex = itemdata.findIndex((item) => item?.id === over.id);
        if (oldIndex === -1 || newIndex === -1) {
            console.warn("Drag item not found", { active, over });
            return;
        }
        const newOrder = arrayMove(itemdata, oldIndex, newIndex);
        setItemdata(newOrder);
        for (let i = 0; i < newOrder.length; i++) {
            const item = newOrder[i];
            const newIndexStage = newOrder.length - i; // descending
            if (item?.indexstage !== newIndexStage) {
                try {
                    await updateDoc(doc(db, "projectstaskitem", item.id), {
                        indexstage: newIndexStage,
                    });
                } catch (err) {
                    console.error(`Failed to update item ${item.id}:`, err);
                }
            }
        }
    };
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    return (
        
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext
                items={itemdata.filter(item => item && item.id).map((item) => item.id)}
                strategy={verticalListSortingStrategy}
            >
                {itemdata.filter(item => item && item.id).map((datarow) => (
                    <Itemwssortable key={datarow.id} datarow={datarow} navigate={navigate} />
                ))}
            </SortableContext>
        </DndContext>

    )
}